import { getRequestListLight } from '../../../../api'
import {
  InputAsyncSelect as InputAsyncSelectComponent,
  InputSelectControl,
} from '../../../Select'
import { Container } from '../../Container'
import { useSelectState } from '../Selects.hooks'
import { toRequestAsyncSelectItems } from '../Selects.utils'

import ServiceRequestIcon from '../../../../icons/service-request.svg'

function InputSelect() {
  const { handleClear, handleSelectItem, value } = useSelectState()

  return (
    <Container label='Async input select with search input inside control'>
      <InputAsyncSelectComponent
        Control={InputSelectControl}
        EntityIcon={ServiceRequestIcon}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: 'Select',
            },
          },
        }}
        getData={getRequestListLight}
        style={{ width: 240 }}
        toPreparedItems={toRequestAsyncSelectItems}
        value={value}
        onClear={handleClear}
        onSelectItem={handleSelectItem}
      />
    </Container>
  )
}

export default InputSelect
